import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { update_page_meta } from "../../actions/page/header";
import { listStoresUnderReview } from "../../actions/store/store";
import PageHeader from "../../components/page/PageHeader";
import { Modal } from "bootstrap";
import StoreModal from "./StoreModal";
import { useNavigate } from "react-router-dom";
import { HomePageURL } from "../../assets/const";
// import OrganizationScroller from "../../components/OrganizationScroller";
import { useSelectedOrganizations } from "../../reducers/accounts/user";
import { reviewAcceptStore } from "../../actions/store/store";

const StoreUnderReviewList = ({ update_page_meta, reviewAcceptStore }) => {
  update_page_meta({
    title: "Stores Under Review",
    description: "All stores under review",
  });
  // const selectedOrganizations = useSelectedOrganizations();
  const [perPage, setPerPage] = useState(9);
  const [Stores, setStores] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [fetching, setFetching] = useState(false);
  const bottomElementRef = useRef();
  const handleAcceptStore = (id) => {
    console.log("started");
    reviewAcceptStore(id);
  };
  useEffect(() => {
    const fetchMore = async () => {
      if (page > totalPages || fetching) return;
      try {
        setFetching(true);
        const response = await listStoresUnderReview(page, perPage);
        if (response.success) {
          setStores((prevStores) => {
            if (page === 1) {
              return response.stores; // Set the initial stores
            } else {
              return [...prevStores, ...response.stores]; // Append new stores
            }
          });
          setTotalPages(response.num_pages);
          setPage(page + 1);
        }
      } catch (error) {
        console.error("Error fetching more products:", error);
      } finally {
        setFetching(false);
      }
    };

    const options = {
      root: null, // viewport
      rootMargin: "0px",
      threshold: 0.1, // When 10% of the element is visible, trigger the callback
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        fetchMore();
      }
    }, options);

    const bottomElement = bottomElementRef.current;

    if (bottomElement) {
      observer.observe(bottomElement);
    }

    return () => {
      if (bottomElement) {
        observer.unobserve(bottomElement);
      }
    };
  }, [bottomElementRef, page, totalPages, fetching]);
  const [Store, setStore] = useState(null);
  const rows = Stores?.map((store, index) => {
    return (
      <tr key={index}>
        <td></td>
        <td>{store?.name}</td>
        <td>{store?.store_type}</td>
        <td>{store?.added_by}</td>
        <td>{store?.created_at}</td>
        <td>{store?.status}</td>
        <td>
          {store?.status === "PENDING" && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                // justifyContent: "space-around",
                gap: "10px",
              }}
            >
              <button
                className="btn btn-success"
                onClick={() => handleAcceptStore(store?.id)}
              >
                Accept
              </button>
              <button className="btn btn-danger">Reject</button>
            </span>
          )}
        </td>
      </tr>
    );
  });
  return (
    <>
      <PageHeader title="Stores Under Review" />
      <div className="row layout-top-spacing" id="cancel-row">
        <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            {/* <OrganizationScroller /> */}
            <div className="table-responsive mb-4 mt-4">
              <table
                id="zero-config"
                className="table table-hover"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th className="no-content"></th>
                    <th>Name</th>
                    <th>Store Type</th>
                    <th>Added By</th>
                    <th>Created At</th>
                    <th>Status</th>
                    <th className="no-content"></th>
                  </tr>
                </thead>
                <tbody>{rows}</tbody>
                <tfoot ref={bottomElementRef}></tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <StoreModal Store={Store} setStore={setStore} />
    </>
  );
};

export default connect(null, { update_page_meta, reviewAcceptStore })(
  StoreUnderReviewList
);
